export default __webpack_public_path__ + "static/media/1_english.c49738f9.jpg";